export const IEyeicon = (props) => {
  const {fill, ...rest} = props
  return (
    <svg
      width="20"
      height="15"
      viewBox="0 0 20 15"
      fill="transparent"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M2.21444 8.26823C2.10377 8.09299 2.04843 8.00537 2.01745 7.87022C1.99418 7.7687 1.99418 7.60861 2.01745 7.50709C2.04843 7.37194 2.10377 7.28432 2.21444 7.10908C3.12902 5.66093 5.85134 2 10 2C14.1487 2 16.871 5.66093 17.7856 7.10908C17.8962 7.28432 17.9516 7.37194 17.9825 7.50709C18.0058 7.60861 18.0058 7.7687 17.9825 7.87022C17.9516 8.00537 17.8962 8.09299 17.7856 8.26823C16.871 9.71638 14.1487 13.3773 10 13.3773C5.85134 13.3773 3.12902 9.71639 2.21444 8.26823Z"
        stroke={props.fill || "#737D86"}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 10.1267C11.3465 10.1267 12.438 9.03512 12.438 7.68866C12.438 6.34219 11.3465 5.25066 10 5.25066C8.65353 5.25066 7.56201 6.34219 7.56201 7.68866C7.56201 9.03512 8.65353 10.1267 10 10.1267Z"
        stroke={props.fill || "#737D86"}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
